module.exports = __webpack_public_path__ + "static/IMG_2352-3752a3924966a45762ac80b7c66ac5e9.jpg";